import { render, staticRenderFns } from "./previewInformation.vue?vue&type=template&id=20979581&scoped=true&"
import script from "./previewInformation.vue?vue&type=script&lang=js&"
export * from "./previewInformation.vue?vue&type=script&lang=js&"
import style0 from "./previewInformation.vue?vue&type=style&index=0&id=20979581&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20979581",
  null
  
)

export default component.exports